import { render, staticRenderFns } from "./TaxiInfo.vue?vue&type=template&id=3b80f4c6&"
import script from "./TaxiInfo.vue?vue&type=script&lang=js&"
export * from "./TaxiInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports